var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"text-center"},[(_vm.error.statusCode !== 404)?_c('div',[_c('h1',[_vm._v(_vm._s(_vm.error.message))]),_vm._v(" "),_c('nuxt-link',{staticClass:"primary",attrs:{"to":"/","tag":"v-btn"}},[_vm._v("\n      Home page\n    ")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }